import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { initialCittaState } from './citta.state';
import { init } from './citta.utility';

export const CittaStore = signalStore(
  { providedIn: 'root' },
  withState(initialCittaState),

  withMethods((store, injector = inject(Injector)) => ({
    init: init(injector, store),
  })),
);
